import apiClient from '@/api/client'
import type { ApiResponse } from '@/types/api'
import type { Objective, CreateObjectiveFormData, UpdateObjectiveData } from '../types'

export const objectivesApi = {
  fetchAll: () =>
    apiClient.get<ApiResponse<Objective[]>>('/objectives'),

  create: (data: CreateObjectiveFormData) =>
    apiClient.post<ApiResponse<Objective>>('/objectives', data),

  update: (id: string, data: UpdateObjectiveData) =>
    apiClient.patch<ApiResponse<Objective>>(`/objectives/${id}`, data),
}
